module.exports = __webpack_public_path__ + "img/77436.504a4bb9.svg";